<template>
    <div>
      <div class="ccode"></div>
      <main class="main-page">
        <div class="search-anime">
          <input  @input="searchAnime"  type="text" name="inputAnime" placeholder="Поиск" autocomplete="off">
          <router-link to="/filter">
            <i class='fas fa-sliders-h'></i>
          </router-link>
        </div>
        <titles-filter @update="getUpdate" :showFilterBlock="showFilterBlock"></titles-filter>
        <div class="hashtag-title" style="max-width: 1165px; width: 100%;margin: -5px auto;">
          <h3 ref="hashtag">{{ decodeURIComponent(hashtagTitle) }}</h3>
        </div>
        
        <div class="anime-cards">
          <!-- <keep-alive> -->
            <anime-list-cards :anime_list="animeList"></anime-list-cards>
          <!-- </keep-alive> -->
          
        </div>
        <infinity-preloader :startPreloader="startInfinityPreloader"></infinity-preloader>
      </main>
      <button-page-up></button-page-up>
      <div ref="observer" class="observer"></div>
    </div>
  </template>
  
<script>
/////////////////////////////////// IMPORTS///////////////////////////////
import axios from "axios";
//import VueLazyload from 'vue-lazyload'ds

import KindAnime from '@/widgets/KindAnime.vue'
import WatchingAnime from '@/widgets/WatchingAnime.vue'
import AnimeNewSwiper from '@/widgets/AnimeNewSwiper.vue'
import isBugButton from '@/shared/ui/buttons/isBugButton.vue'
import ButtonPageUp from '@/shared/ui/buttons/ButtonPageUp.vue'
import InfinityPreloader from "@/widgets/InfinityPreloader.vue";
import TitlesFilter from "@/widgets/TitlesFilter.vue";
import AnimeListCards from "@/widgets/AnimeListCards.vue";

import { removeDuplicatesG } from '@/shared/lib/helpers.js'
import { setHeadTitle, setHeadTitleG } from '@/shared/helpers/messy-helpers.js'

console.log(removeDuplicatesG);
// import { EffectCreative } from "swiper";
/////////////////////////////////// IMPORTS END////////////////////////////

  
  export default {
    data() {
      return {
        url: "",
        main_anime_url: "https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial",
        search_anime_url: 'https://kodikapi.com/search?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial&title=',
        new_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&types=anime,anime-serial&year=2023',
        movie_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=movie',
        serial_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=tv&year=2022,2021,2020,2019,2018,2017,2016,2015,2014,2013,2012',
        special_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=special',
        ova_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=ova',
        ona_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&anime_kind=ona',
        studio_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&limit=100&types=anime,anime-serial&anime_studios=',
        genre_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&limit=100&types=anime,anime-serial&anime_genres=',
        writer_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&limit=100&types=anime,anime-serial&writers=',
        director_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&limit=100&types=anime,anime-serial&directors=',
        filter_anime_url: 'https://kodikapi.com/list?token=d2dfd98afa2be0897d2e7b4f477d5a61&with_material_data=true&limit=100&lgbt=false&types=anime,anime-serial&sort=year',
        animeList: {},
        searchText: "",
        status: "",
        isMainPage: true,
        hashtagTitle: "",
        audio: "",
        watching_list: [],
        listOfGenres: null,
        listOfStudios: null,
        isAuthedAndMain: false,
        show_title_cards_block: true,
        nextPageURL: '',
        startInfinityPreloader: false,
        showFilterBlock: false
      };
    },
    components: {
      'kind-anime': KindAnime,
      'watching-anime': WatchingAnime,
      'anime-new-swiper-block': AnimeNewSwiper,
      'is-bug-button': isBugButton,
      'button-page-up': ButtonPageUp,
      'infinity-preloader': InfinityPreloader,
      'titles-filter': TitlesFilter,
      'anime-list-cards': AnimeListCards
    },
    watch:{
      $route(newPath, oldPath){
        this.isFilterBlock = false;
        if(newPath.path === '/filter'){
          this.showFilterBlock = true;
          this.hashtagTitle = "";
        }else{
          this.showFilterBlock = false;
        }
        
        this.showAnime(newPath.path);
      }
    },
    mounted(){
      

      localStorage.setItem('searchText', "");
      const options = {
        rootMargin: '-200px',
        threshold: 0
      }
      const callback = (entries, observer) =>{
        if(entries[0].isIntersecting && this.nextPageURL !== null){
          console.log("ПЕРЕСЕЧЧЕНИЕ");
          this.showMoreTitles();
        }
      }
      document.querySelector('.search-anime input').value = localStorage.getItem('searchText');
      this.searchAnime();
      const observer = new IntersectionObserver(callback, options);
      observer.observe(this.$refs.observer)

      document.querySelector('.header').addEventListener( "mousedown" , function(){
        localStorage.setItem('searchText', "");
        // document.querySelector('.search-anime input').value = "";
        
      });
    },
    created(){
      //Установка темы
      console.log(this.$route.path)
      
      this.ShowThemeFromLocalStorage();

      let firstPathName = window.location.pathname.split('/')[1];
      let secondPathName = window.location.pathname.split('/')[window.location.pathname.split('/').length-1]
      
      if(isExeptPath(secondPathName)){
        this.hashtagTitle = getRuPathName(secondPathName);
        console.log(this.hashtagTitle);
        setHeadTitleG(this.hashtagTitle)
      }else{
        this.hashtagTitle = '#' + secondPathName;
        setHeadTitleG(decodeURIComponent(secondPathName));
      }

      function isExeptPath(secondPathName){
        let exeptArr = ['new_2023', 'movie', 'tv', 'ova', 'ona', 'special', 'music', 'filter'];
        for(let item of exeptArr){
          if(item === secondPathName){
            
            return true;
          }
        }
        return false;
      }

      function getRuPathName(secondPathName){
        let exeptArrEn = ['new_2023', 'movie', 'tv', 'ova', 'ona'];
        let exeptArrRu = ['Новинки 2023', 'Полнометражные', 'Сериалы ', 'OVA', 'ONA', 'special', 'music'];
        for(let i = 0; i < exeptArrEn.length;i++){
          if(exeptArrEn[i] === secondPathName){
            return exeptArrRu[i];
          }
        }
        return '';
      }
      console.log(secondPathName)
      this.showAnime('/' + firstPathName, secondPathName);
      if(this.$route.path === '/filter'){
        this.showFilterBlock = true;
      }else{
        this.showFilterBlock = false;
      }
      //Аудио чит-кода
      // console.log('AUDIO' + window.location.protocol)
      // this.audio = new Audio(`http://${window.location.hostname}/cheat.mp3`);
    },
    methods: {
      showFilterBlockFunc(isShow){
        if(this.$route.path === '/filter'){
          this.showFilterBlock = isShow;
        }else{
          this.showFilterBlock = false;
        }
      },
      getUpdate(list, nextPage){
        console.log(list);
        this.animeList = list;
        this.nextPageURL = nextPage;
      },
      showAnime: async function(kind = '/', param) {
        if(this.searchText === "" && this.$route.path === '/filter'){
          this.showFilterBlock = true;
        }
        
        let url = this.getPageUrl(kind, param);
        this.animeList = await this.getKodikDataAndRemoveDuplicates(url);
        
      },
      //REFACTORED
      async getKodikDataAndRemoveDuplicates(kodik_url){
        if(kodik_url){
          let response = await axios.get(kodik_url);
          this.nextPageURL = response.data.next_page;
          return removeDuplicatesG(response.data.results);
        }
      },
      showMoreTitles(){
        if(this.searchText == ""){
          this.startInfinityPreloader = true;
          // console.log(this.nextPageURL);
        
          axios //Get next page with 100 titles
            .get(this.nextPageURL)
            .then((response) => {
              let rem_dub = removeDuplicatesG(response.data.results);
              rem_dub = this.removeDuplicatesMoreTitles(this.animeList, rem_dub)
              console.log(this.animeList);
              this.startInfinityPreloader = false;
              this.nextPageURL = response.data.next_page;
              this.animeList = this.animeList.concat(rem_dub)
            })
            .catch((error) => {
              this.startInfinityPreloader = false;
              console.error(error);
            });
        }
        
      },
      
      clearLocalStorageSearchText(){
        localStorage.setItem('searchText', '');
        document.querySelector('.search-anime input').value = "";
      },
      searchAnime: function() {
        this.showFilterBlock = false;
        // this.hashtagTitle = "";
        this.searchText = document.querySelector('.search-anime input').value; //сделать через v-bind или v-model
        localStorage.setItem('searchText', this.searchText);
        let url = this.search_anime_url + this.searchText;
        //Откат на состояние базовой разметки странцы. С базовыми блоками и базовым url.
        if(this.searchText === ""){
          this.showAnime(window.location.pathname);
        }
        //GET запрос на search url
        axios
          .get(url)
          .then(response => {
            //Удаление дубликатов из объекта с тайтлами и запись в основной массив тайтлов
            this.animeList = removeDuplicatesG(response.data.results, true);
          })
          .catch(error => {
            console.log(error);
          });
      },
      

    /////////////////////////////////////////////
    /////////////ADDITIONAL ELEMENTS/////////////
    /////////////////////////////////////////////

     
      //REFACTORED FUNCTION, NOT CLEAN
      //Описание: метод достает данные из loacalStorage и в зависимости от данных применяет нужную тему страницы,
      //путем изменения href тега link в head'e документа.
      ShowThemeFromLocalStorage: function(){
        let theme_value = localStorage.getItem('theme');
        let themes = {
          'white': 'themes/white.css',
          'not pink': 'themes/not_pink.css',
          'pearl': 'themes/pearl.css',
          'black': '#'
        }
        for (let theme in themes){
          if(theme === theme_value){
            let theme_path = themes[theme];
            document.querySelector('link.page_theme').href = './' + theme_path;
          }
        }
      },

    /////////////////////////////////////////////
    /////////////CLEAN FUNCTIONS/////////////////
    /////////////////////////////////////////////
      //CLEAN FUNCTION
      //Описание: возвращает url api по path страницы сайта
      //@param {string} берет path страницы
      //@return {string} возвращает новую строку url api kodik
      getPageUrl: function(kind, param){
        let pagePathes = [
          {path: '/', endpoint: this.main_anime_url},
          {path: '/new_2023', endpoint: this.new_anime_url},
          {path: '/tv', endpoint: this.serial_anime_url},
          {path: '/movie', endpoint: this.movie_anime_url},
          {path: '/ova', endpoint: this.ova_anime_url},
          {path: '/ona', endpoint: this.ona_anime_url},
          {path: '/special', endpoint: this.special_anime_url},
          {path: '/studio', endpoint: this.studio_anime_url},
          {path: '/genre', endpoint: this.genre_anime_url},
          {path: '/writer', endpoint: this.writer_anime_url},
          {path: '/director', endpoint: this.director_anime_url},
          {path: '/filter', endpoint: this.filter_anime_url}
        ]
        for (let item of pagePathes){
          
          if(item.path === kind){
            if(kind === '/studio' || kind === '/genre' || kind === '/writer' || kind === '/director'){
              return item.endpoint + param;
            }else if(kind === '/filter'){
              return item.endpoint;
            }
            return item.endpoint;
          }
        }      
      },
      removeDuplicatesMoreTitles(arr1, arr2) {
          // Создаем множество (Set) из значений shikimori_id в первом массиве объектов
          const shikimoriIds = new Set(arr1.map(obj => obj.shikimori_id));

          // Фильтруем второй массив объектов и удаляем объекты, у которых shikimori_id совпадает с теми, что есть в множестве
          const filteredArr2 = arr2.filter(obj => !shikimoriIds.has(obj.shikimori_id));

          return filteredArr2;
      },
      
    }
  };
  </script>
  
  <style scoped>
  .main-page{
    margin-bottom: 79px;
  }


  [data-title]:hover:after {
      visibility: visible;
  }
  
  .selectr-container{
    color: black;
  }
  
  .selectr-container .selectr-input{
    padding: 5px 10px;
  }
  
  #select_multiple_genres ul{
    color: black;
  }
    
  [data-title]:after {
      content: attr(data-title);
      background-color: #262626;    
      color: #ffffff;
      font-size: 80%;
      position: absolute;
      border-radius: 5px;
      border: 1px solid #1d1d1d;
      padding: 4px 8px 4px 8px;
      visibility: hidden;
  }
  
  .search-anime i{
  position: absolute;
  color: #ffffff;
  right: 31px;
  top: 9px;
  font-size: 19px;
  transition: .2s;
  padding: 6px 6px 4px 6px;
  border-radius: 5px;
  border: 1px solid #5555555e;
  border-radius: 5px;
  background: #b7b7b738;
}

.search-anime i:hover{
  color: #3584ff;
  background-color: #b7b7b76e;
}
  
  .h2-monts{
    font-size: 20px;
    font-family: 'Montserrat', sans-serif;
  }
  
  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: "Exo 2", sans-serif;
    margin-bottom: 60px;
  }
  
  .search-anime{
    position: relative;
    width: 100%;
    max-width: 1000px;
    padding: 0 20px;
    margin-bottom: 20px;
  }
  
  .hashtag-title h3{
    text-align: left; 
    margin-left: 16px;
    margin-bottom: 10px;
    font-size: 30px;
    text-shadow: 1px 1px 1px rgb(177, 215, 255);
  }
  
  .forMobile .three-dots{
    margin-top: 15px;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 204px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    text-align: center;
  }
  
  .search-anime input{
    width: 100%;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px;
    border-top:none;
    border-right:none;
    border-left:none;
    border-bottom: none;
    /*border-bottom-color:  white;*/
    padding: 10px 20px;
    font-size: 22px;
    font-family: 'Montserrat', sans-serif;
    background: transparent;
    color: white;
    text-align: center;
    /*background: #262626;*/
  /*  box-shadow: inset 3px 3px 8px #7a7a7a, inset -2px -2px 10px #4a4a4a;*/
    box-shadow: inset 3px 3px 8px #272727, inset -2px -2px 10px #3a3a3a;
    box-sizing: border-box;
  }
  
  .search-anime input:focus{
    outline: 2px solid #72b5ff;
  /*  border-bottom:none;*/
    border-bottom-right-radius: 8px;
    border-bottom-left-radius: 8px;
  /*  outline: none;*/
    border-bottom:  none;
    box-shadow: 0 0 83px 45px #007aff3d;
  /*  box-shadow: inset 3px 3px 8px #4f86e9, inset -2px -2px 10px #4a4a4a;*/
  }
  
  
  
  
  
  .anime-card {
    margin: 1rem;
    flex: 1 0 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
  
  /*  opacity: 0.1;*/ 
  }
  
  .img-hidden{
    position: relative;
    width: 225px;
    height: 305px;
    border-radius: 8px;
    overflow: hidden;
  }
  
  .main-page .img-hidden span{
    position: absolute;
    background: #3e3e3e; 
    border-radius: 5px;
    padding: 2px 8px;
    bottom: 10px;
    left: 10px;
  /*  right: 10px;*/
  }
  
  .main-page .img-hidden img{
    width: 14px; 
    transform:translateY(1px);
    transition: .5s;
  }
  
  .main-page .img-hidden{
    transition: .3s scale, 3s;
  }
  
  .main-page .img-hidden:hover{
    box-shadow: 0 0 63px 35px #007aff3d;
  }
  
  .main-page .img-hidden img:hover{
    transform:scale(1.3);
  }
  
  .main-page .img-hidden:hover{
  
    transform:scale(1.1);
  }
  
  .onlyForMobile{
    display: none;
  }
  
  
  .overflow-mobile{
    width: 100%;
    overflow-x: auto;
    max-width: 750px;
  }
  
  .kinds{
    width: 708px;
    margin: 0 5px 0 20px;
  }
  
  .ccode{
    width: 359px;
    height: 30px;
    background-color: #2f2f2f;
    position: absolute;
    left: 50px;
    top: 45px;
    padding: 6px 20px;
    background-image: url(https://anione.fun/ccode.jpg);
    background-size: 360px;
    background-repeat: no-repeat;
    display: none;
    transition: .5s;
    z-index: 100;
  }
  
  
  
  
  
  .observer{
    position: absolute;
    height: 10px;
    width: 100%;
    /* background-color: green; */
    margin-top: -330px;
    /* margin-bottom: 130px; */
    z-index: -1;
  }
  
  /*MOBILE*/
  
  @media only screen and (max-width: 600px) {
    .hashtag-title h3{
      margin-left: 20px;
      margin-bottom: 5px;
      margin-top: 0;
      text-shadow: 1px 1px 0px rgb(177, 215, 255);
    }
  
    
    .ccode{
      left: 0px;
      top: 30px;
      transform: scale(0.8);
    }
  
    .anime-card{
      display: flex;
      flex-direction: row;
      align-items: flex-start;
      margin: 15px 20px;
      opacity: 1;
    }
  
    #first_main{
      margin-left: -5px;
  
    }
  
    .img-hidden {
      width: 120px;
      height: 155px;
      border-radius: 10px;
      /*opacity: 0.1; */
      background-size: cover;
    }
  
    .main-page .img-hidden span{
      bottom: 4px;
      left: 2px;
      transform: scale(0.8);
    }
  
    .forMobile .three-dots{
      margin: 0 0 5px 20px;
      text-align: left;
    }
  
    .onlyForMobile{
      display: block;
      margin: 0 0 0 20px;
      font-weight: bold;
      color: grey;
    }
  
    .onlyForMobile img{
      width: 22px;
      transform: translateY(4px);
    }
  
    .onlyForMobile span{
      margin-right: 10px;
      color: white;
    }
  
    .onlyForMobile .blue{
      background-color: #0d6efd;
      padding: 4px 5px 5px 5px;
      border-radius: 4px;
    }
  
    .onlyForMobile .red{
      background-color: red;
      padding: 3px 5px;
      border-radius: 4px;
    }
  
    .onlyForMobile .green{
      background-color: green;
      padding: 3px 5px;
      border-radius: 4px;
    }
    
  }
  
  
  </style>